// Конфигурация webhook URL для n8n (через прокси)
import { fetchWithRetry } from './n8n-config';

// Пути webhook эндпоинтов (без домена и без /webhook/ т.к. он уже в N8N_BASE_URL)
export const WEBHOOK_PATHS = {
  replaceModelKie: '/replace-model-kie-airun',
  replaceBackgroundKie: '/replace-background-kie-airun',
  upscale: '/upscale',
  objectBackground: '/object',
  objectBackgroundKie: '/object-kie-airun',
  photoSession: '/photo-session-airun',
  photoSessionKie: '/photo-session-kie-airun',
  changingRoom: '/changing-room-airun',
  changingRoomKie: '/changing-room-kie-airun',
  photoToVideo: '/photo-to-video-airun',
  photoToVideoKie: '/photo-to-video-kie-airun',
  scenarioGenerate: '/airun-scenario-generate',
  photoGenerationKie: '/photo-generation-kie-airun',
  vectorAi: '/vector-ai-airun',
  videoMerge: '/video-merge-airun',
  videoMergePoll: '/video-merge-poll',
  autoProductAnalyze: '/auto-product-analyze-airun',
  autoProductGenerate: '/auto-product-generate-kie-airun',
  autoProductTaskList: '/auto-product-task-list-airun'
};

// Helper функция для отправки через прокси.
// retryOpts: для запросов генерации передавайте { retries: 0 } — повтор на 504
// запускает дублирующую генерацию (и тратит деньги провайдера), а не «повторяет» ту же.
export const sendWebhookRequest = async (webhookPath, data, retryOpts = undefined) => {
  const response = await fetchWithRetry('/api/n8n-proxy', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      endpoint: webhookPath,
      data
    })
  }, retryOpts);
  
  if (!response.ok) {
    const errorData = await response.text();
    throw new Error(errorData || `Webhook request failed: ${response.status}`);
  }
  
  return response.json();
};
